import { useContext } from "react";

import { LandingPageAnalyticsContext } from "./context";

export const useLandingPageAnalyticsContext = () => {
  const context = useContext(LandingPageAnalyticsContext);

  if (!context) {
    throw new Error(
      "useLandingPageAnalyticsContext can only be used inside LandingPageAnalyticsContext",
    );
  }

  return context;
};
